<div class="container-xxl store-info-bar-wrapper">
  <div class="store-info-bar-text">
    <p class="store-info-bar-title">Extend Your Platform. Grow Faster.</p>
    <p class="store-info-bar-subtitle">
      Discover, activate, and monetize your NetSapiens Platform by adding integrations with ease.
    </p>
  </div>
  <div class="store-info-bar-logo">
    <img src="assets/img/marketplace_logo.png" alt="Crexendo Marketplace">
    <!-- <img src="assets/img/logo_dark_crexendopoweredbynetsapiens.png" alt="Crexendo">
    <div class="store-info-bar-marketplace">
      <span class="store-info-bar-marketplace-text"><span class="market">MARKET</span><span class="place">PLACE</span></span>
      <i class="fas fa-magnifying-glass store-info-bar-marketplace-icon"></i>
    </div> -->
  </div>
</div>
